<script lang="ts" setup>
import type { PropType } from 'vue';
import { Link } from "@inertiajs/vue3";
import CarretsBlack from "@icons/carrets-black.svg";
interface FeaturedLink {
    title: string;
    caption: string;
    link: string;
    aria_label: string;
}

const props = defineProps({
    featuredLink: {
        type: Object as PropType<FeaturedLink>,
        default(){
            return {
                title: "Title",
                caption: "Caption",
                link: "#",
                aria_label: "Link"
            }
        }
    }
});
</script>
<template>
    <Link as="div" :href="featuredLink.link" class="launcher-item" 
        :aria-label="featuredLink.aria_label"
        role="button"
        tabindex="0" 
    >
        <div class="animation-desk">
            <div class="launcher-item__wrapper">
                <div class="fill">
                    <div class="launcher-item__wrapper-text">
                        <p class="title-s">{{ featuredLink.title }}</p>
                        <p class="paragraph-caption">{{ featuredLink.caption }}</p>
                    </div>
                    <div class="carret"> 
                        <CarretsBlack role="presentation" />
                    </div>
                </div>
            </div>
        </div>
    </Link>

</template>